import { GameObjects } from 'phaser';
import { ARCADE_HEX, MOLDURA } from '../config/theme';
import { MolduraPixel } from './MolduraPixel';

/**
 * Campo de texto do tema Figma: moldura pixel no canvas e um <input>
 * transparente por cima (camada DOM), para o teclado do tablet funcionar.
 */
export class CampoArcade extends GameObjects.Container {
    constructor (scene, x, y, config = {}) {
        super(scene, x, y);
        scene.add.existing(this);

        const {
            largura = 368, altura = MOLDURA.ALTURA, placeholder = '', rotuloAcessivel = placeholder,
            tipo = 'text', modoTeclado = 'text', maximo = 80, aoDigitar = null, aoEnter = null
        } = config;

        const moldura = scene.add.graphics();
        moldura.clear();
        MolduraPixel.desenhar(moldura, -largura / 2, -altura / 2, largura, altura, {
            fundo: ARCADE_HEX.CAMPO, fio: ARCADE_HEX.FIO_CAMPO, fioMeio: ARCADE_HEX.BRANCO
        });

        this.elemento = document.createElement('input');
        this.elemento.type = tipo;
        this.elemento.inputMode = modoTeclado;
        this.elemento.maxLength = maximo;
        this.elemento.className = 'campo-arcade';
        this.elemento.placeholder = placeholder;
        this.elemento.autocomplete = 'off';
        this.elemento.spellcheck = false;
        this.elemento.setAttribute('aria-label', rotuloAcessivel);
        this.elemento.style.width = `${largura - 44}px`;
        this.elemento.style.height = `${altura - 16}px`;

        this.elemento.addEventListener('input', () => aoDigitar?.(this));
        this.elemento.addEventListener('keydown', (evento) => {
            // O Phaser escuta o teclado na janela; sem isto, digitar "S" no
            // campo dispararia atalhos de cena.
            evento.stopPropagation();
            if (evento.key === 'Enter') aoEnter?.(this);
        });

        this.dom = scene.add.dom(0, 0, this.elemento);
        this.add([moldura, this.dom]);
    }

    get valor () { return this.elemento.value; }

    focar () {
        this.elemento.focus();
        return this;
    }
}
